<template>
  <div>
    <div class="page-form-header small-header">
      <h1>Privacy consent</h1>
    </div>
    <div class="page-form-content">
      <div class="consent-box">
        <h6>{{ agreements.diagnostic.title }}</h6>
        <ul>
          <li v-for="(point, i) in agreements.diagnostic.points" :key="i">{{ point }}</li>
        </ul>
      </div>

      <v-form-group :validator="$v.profile.diagnosticAcceptedB">
        <b-form-checkbox class="pull-down"
                         id="diagnosticCheckbox"
                         v-model="profile.diagnosticAcceptedB"
                         name="diagnosticCheckbox">
          {{ agreements.diagnostic.checkboxLabel }}
        </b-form-checkbox>
      </v-form-group>
    </div>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import agreements from "../../../../store/constants/registration-agreement";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('profile');
  
  export default {
    mixins: [formMixin],
  
    data() {
      return { agreements };
    },
  
    validations: {
      profile: {
        diagnosticAcceptedB: { required }
      }
    },
  
    computed: {
      ...mapState(["profile"])
    },
  
    created() {
      this.profile.diagnosticAcceptedB = false;
    }
  };
</script>